module.exports = __webpack_public_path__ + "sales-hero-882c79e62cf013caab8b3414c24af90c.webp";